import { CustomToast, TamaguiProvider, TamaguiProviderProps, ToastProvider, config, PortalProvider } from '@my/ui'
import { APP_ENV } from '@my/config'
///import { useColorScheme } from 'react-native'
import { AuthProvider } from './auth'
import { ToastViewport } from './ToastViewport'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RegisterFCMMessageAction, LongPollingSvc, useAuthedRequestFn } from '@my/util'
import { useEffect } from 'react'
import { useUser } from '@clerk/react'
import { StatsigInitProvider } from './analytics';
import { useMiscProviderFn } from './misc'
//import type { SolitoAppProps } from 'solito'
export * from './contexts'

interface ProviderProps extends Omit<TamaguiProviderProps, 'config'> {
  clerkPublishableKey: string
}

const queryClient = new QueryClient();
//RegisterFCMMessageAction('financial-review', () => queryClient.refetchQueries({ queryKey: ['financial-review']}));

function MiscProvider({ children }) {
  const {user} = useUser();

  useMiscProviderFn(queryClient);

  return user ? <StatsigInitProvider user={user}>
    {children}
  </StatsigInitProvider> : children;
}

export const UtilProviders: React.FC<{
  clerkPublishableKey: string;
  children: any;
}> = ({children, ...rest}) => {
  return <AuthProvider publishableKey={rest.clerkPublishableKey}>
    <MiscProvider>
      <QueryClientProvider client={queryClient}>
          {children}
      </QueryClientProvider>
    </MiscProvider>
  </AuthProvider>
}

export function Provider({ children, ...rest }: ProviderProps) {
  //const scheme = useColorScheme()
  //const [queryClient] = useState(() => new QueryClient())

  return (
    <TamaguiProvider
      config={config}
      //disableInjectCSS
      defaultTheme={/* scheme === 'dark' ? 'dark' : */ 'light'}
      {...rest}
    >
      <UtilProviders clerkPublishableKey={rest.clerkPublishableKey}>
        <ToastProvider
          swipeDirection="horizontal"
          duration={6000}
          native={
            [
              /* uncomment the next line to do native toasts on mobile. NOTE: it'll require you making a dev build and won't work with Expo Go */
              // 'mobile'
            ]
          }
        >
          {children}

          <CustomToast />
          <ToastViewport top="$8" left={0} right={0} />
        </ToastProvider>
      </UtilProviders>
    </TamaguiProvider>
  )
}
